import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Bullet from './Bullet';

/**
 * Bullets
 *
 * This component is in charge of displaying
 * some bullets
 *
 * @return {jsx}
 */

const Bullets = ({ className, bulletCount, currentBullet }) => {
  const bullets = [];
  for (let bulletIndex = 0; bulletIndex < bulletCount; bulletIndex++) {
    const isActivated = bulletIndex === currentBullet;
    bullets.push(<Bullet key={bulletIndex} activated={isActivated} />);
  }
  return <div className={className}>{bullets}</div>;
};

/**
 * PropTypes Validation
 */
const { string, number } = PropTypes;
Bullets.propTypes = {
  className: string,
  bulletCount: number,
  currentBullet: number,
};

/**
 * Default Props
 */
Bullets.defaultProps = {
  className: '',
  bulletCount: 0,
  currentBullet: 0,
};

export default styled(Bullets)`
  position: absolute;
  bottom: 3px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
`;



// WEBPACK FOOTER //
// ./src/components/Slider/Bullets/index.js